import React from "react";
import "./Services.css";

export default function Services() {
  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="services-hero-card">
          <div className="services-badge">Services</div>

          <h1 className="services-title">
            Intelligence systems, software architecture, and AI product
            delivery.
          </h1>

          <p className="services-lead">
            At <strong>Conscious Neurons</strong>, we design and deliver systems
            that bring together artificial intelligence, automation, product
            architecture, and human-centered software design. Our services are
            built for organizations that want more than isolated features — they
            want structured intelligence inside real operational workflows.
          </p>
        </div>
      </section>

      <section className="services-section">
        <div className="services-section-head">
          <div className="services-section-tag">Core offerings</div>
          <h2>What we build and integrate</h2>
          <p>
            Our service model covers both deep technical implementation and
            higher-level system design. We do not treat AI as an add-on. We
            treat it as a layer that must be architected carefully across data,
            logic, interface, and user trust.
          </p>
        </div>

        <div className="services-grid services-grid-2">
          <article className="services-card">
            <h3>Neural Network Engineering</h3>
            <p>
              We design and deploy custom machine learning and deep learning
              systems for specific product and business needs. That includes
              architectures for perception, prediction, pattern recognition, and
              language-oriented intelligence.
            </p>
          </article>

          <article className="services-card">
            <h3>AI System Integration</h3>
            <p>
              We integrate intelligent behavior into real products and
              operations, whether through APIs, internal platforms, customer
              systems, dashboards, or workflow tooling.
            </p>
          </article>

          <article className="services-card">
            <h3>Predictive & Prescriptive Analytics</h3>
            <p>
              We create systems that not only analyze past and present data, but
              help forecast likely outcomes and guide better decisions through
              structured intelligence.
            </p>
          </article>

          <article className="services-card">
            <h3>Cognitive Workflow Automation</h3>
            <p>
              We replace repetitive, rigid processes with systems that can
              reason through conditions, adapt to changing input, and support
              more intelligent operational flow.
            </p>
          </article>

          <article className="services-card">
            <h3>AI Ethics & Explainability</h3>
            <p>
              We build with a strong focus on transparency, interpretability,
              and human-centered behavior so that intelligent systems remain
              trustworthy and aligned.
            </p>
          </article>

          <article className="services-card">
            <h3>Custom Software Platforms</h3>
            <p>
              We architect full software systems that combine interface design,
              backend logic, automation, and AI capabilities into one coherent
              product strategy.
            </p>
          </article>
        </div>
      </section>

      <section className="services-section">
        <div className="services-section-head">
          <div className="services-section-tag">Industries</div>
          <h2>Where our systems create value</h2>
          <p>
            The methods behind our work apply across sectors where intelligence,
            prediction, automation, and structured user experience matter.
          </p>
        </div>

        <div className="services-grid services-grid-3">
          <article className="services-card">
            <h3>Fintech</h3>
            <p>
              Decision systems, analytics, automation, and intelligent financial
              workflows built for clarity and speed.
            </p>
          </article>

          <article className="services-card">
            <h3>Healthtech</h3>
            <p>
              Data-informed systems that support structured workflows,
              prediction, and operational intelligence.
            </p>
          </article>

          <article className="services-card">
            <h3>Retail & Commerce</h3>
            <p>
              Recommendation, behavior understanding, inventory logic, and
              customer-facing intelligence systems.
            </p>
          </article>

          <article className="services-card">
            <h3>Logistics</h3>
            <p>
              Workflow optimization, forecasting, intelligent routing logic, and
              automation for operational efficiency.
            </p>
          </article>

          <article className="services-card">
            <h3>Education</h3>
            <p>
              Adaptive systems, structured learning flows, and intelligent tools
              that support engagement and personalization.
            </p>
          </article>

          <article className="services-card">
            <h3>Research & Innovation</h3>
            <p>
              Advanced modeling, experimental architectures, and technical
              systems for teams pushing beyond standard software patterns.
            </p>
          </article>
        </div>
      </section>

      <section className="services-section">
        <div className="services-feature-card">
          <h2>The Conscious Difference</h2>

          <div className="services-points">
            <div className="services-point">
              <span>01</span>
              <p>
                We believe intelligence should serve human goals, not obscure
                them.
              </p>
            </div>

            <div className="services-point">
              <span>02</span>
              <p>
                We treat data as meaningful system memory, not just raw input.
              </p>
            </div>

            <div className="services-point">
              <span>03</span>
              <p>
                We design for long-term clarity, not just short-term MVP output.
              </p>
            </div>

            <div className="services-point">
              <span>04</span>
              <p>
                We build cognition into products with intention, structure, and
                trust.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="services-cta-card">
          <h2>Let’s build intelligence as infrastructure</h2>
          <p>
            Conscious Neurons works with founders, teams, and organizations that
            want software systems capable of more than static execution. If your
            next product or platform needs structured intelligence, we are ready
            to architect it with you.
          </p>
        </div>
      </section>
    </div>
  );
}
